import { size, map } from 'lodash';
import { normalizeWordForComparison } from '../../../utils';

export namespace WordCloud {
  export interface Answer {
    words?: string[]; // raw words
    modifiedAt: number;
  }

  export interface Word {
    normalized: string;
    source: string;
  }

  export namespace Answer {
    export const maxWordLength = 150;
    export const maxWordCount = 200;

    export function numberOfWords(answer: Answer | undefined): number {
      return size(answer && answer.words);
    }

    export function words(answer: Answer | undefined): Word[] {
      return map(
        answer && answer.words,
        (raw): Word => ({
          source: raw,
          normalized: normalizeWordForComparison(raw),
        })
      );
    }

    export function normalizedWords(answer: Answer | undefined): string[] {
      return map(answer && answer.words, (word) => normalizeWordForComparison(word));
    }

    export function sourceWords(answer: Answer | undefined): string[] {
      return (answer && answer.words) || [];
    }

    export function containsWord(answer: Answer | undefined, word: string, caseInSensitive: boolean): boolean {
      const words = Answer.normalizedWords(answer);
      return words.includes(normalizeWordForComparison(word));
    }

    export function isDone(answer: Answer | undefined): boolean {
      return numberOfWords(answer) > 0;
    }
  }
}
